// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TapesRouteImport } from './routes/tapes'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as AuditionsRouteImport } from './routes/auditions'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SnapshotsIndexRouteImport } from './routes/snapshots.index'
import { Route as UnsubscribeTokenRouteImport } from './routes/unsubscribe.$token'
import { Route as SnapshotsIdRouteImport } from './routes/snapshots.$id'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TapesRoute = TapesRouteImport.update({
            id: '/tapes',path: '/tapes',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const CalendarRoute = CalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => rootRouteImport
          })
const AuditionsRoute = AuditionsRouteImport.update({
            id: '/auditions',path: '/auditions',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SnapshotsIndexRoute = SnapshotsIndexRouteImport.update({
            id: '/snapshots/',path: '/snapshots/',getParentRoute: () => rootRouteImport
          })
const UnsubscribeTokenRoute = UnsubscribeTokenRouteImport.update({
            id: '/unsubscribe/$token',path: '/unsubscribe/$token',getParentRoute: () => rootRouteImport
          })
const SnapshotsIdRoute = SnapshotsIdRouteImport.update({
            id: '/snapshots/$id',path: '/snapshots/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuditionsRoute: AuditionsRoute,CalendarRoute: CalendarRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SettingsRoute: SettingsRoute,TapesRoute: TapesRoute,TermsRoute: TermsRoute,SnapshotsIdRoute: SnapshotsIdRoute,UnsubscribeTokenRoute: UnsubscribeTokenRoute,SnapshotsIndexRoute: SnapshotsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)